import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"

const Footer = ({ language }) => {

  const { allDataYaml } = useStaticQuery(
    graphql`
      query {
        allDataYaml {
          edges {
            node {
              caption {
                common {
                  ja {
                    site_title
                    privacy
                    contact
                  }
                  en {
                    site_title
                    description
                    privacy
                    contact
                  }
                }
              }
            }
          }
        }
      }
    `
  )

  const commonCap = allDataYaml.edges[0].node.caption.common

  if (language === undefined || language === null) {
    language = 'ja'
  }
  
  return (
    <footer>
      <div>
        © {new Date().getFullYear()}{` `}{ commonCap[language]["site_title"] }
      </div>
      <ul className="footer-link">
        <li><Link to={`/${language}/privacy-policy`}>{ commonCap[language]["privacy"] }</Link></li>
        <li><Link to={`/${language}/contact`}>{ commonCap[language]["contact"] }</Link></li>
      </ul>
    </footer>
  )
}

export default Footer
